module.exports = __webpack_public_path__ + "img/R-C.526e1baf.png";